import { apiDesignModule } from './modules/api-design';
import { apiSecurityModule } from './modules/api-security';
import { apiIntegrationModule } from './modules/api-integration';
import { apiTestingModule } from './modules/api-testing';

export const apiDevelopmentCourse = {
  id: 'enterprise-api-development',
  title: 'Enterprise API Development & Integration',
  description: 'RESTful APIs, GraphQL, and enterprise integration patterns for internal systems',
  level: 'intermediate',
  totalDuration: '14 hours',
  image: '/api/placeholder/400/300',
  prerequisites: ['Backend development experience'],
  learningOutcomes: [
    'Design and implement enterprise-grade APIs',
    'Integrate with existing enterprise systems and databases',
    'Implement authentication, authorization, and security',
    'Monitor and maintain API performance and reliability'
  ],
  modules: [
    { ...apiDesignModule, order: 1, estimatedTime: 60 },
    { ...apiSecurityModule, order: 2, estimatedTime: 75 },
    { ...apiIntegrationModule, order: 3, estimatedTime: 90 },
    { ...apiTestingModule, order: 4, estimatedTime: 45 }
  ]
};